<section class="projects-section">
  <div class="container">

    <div class="card">

      <div class="page-header">

        <!-- Back Button -->
        <button class="icon-btn back" (click)="backToRoles()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>

        <!-- Dynamic Title -->
        <h3 class="page-title">
          {{ mode === 'create' ? 'Create Role' : mode === 'edit' ? 'Edit Role' : 'Role Details' }}
        </h3>

        <div class="flex-spacer"></div>

        <!-- VIEW MODE → Show Edit + Delete -->
        <div class="header-actions" *ngIf="mode === 'view'">
          <button class="icon-btn edit" (click)="goToEdit()">
            <i class="fa-solid fa-pen-to-square"></i>
          </button>

          <button class="icon-btn delete" (click)="deleteRole()">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

        <!-- EDIT MODE → Show View + Delete -->
        <div class="header-actions" *ngIf="mode === 'edit'">
          <button class="icon-btn view" (click)="goToView()">
            <i class="fa-solid fa-eye"></i>
          </button>

          <button class="icon-btn delete" (click)="deleteRole()">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

      </div>

      <!-- FORM -->
      <form [formGroup]="roleForm" class="form-wrapper">

        <!-- ROLE INFO -->
        <div class="sub-card">
          <h4 class="sub-title">Role Information</h4>

          <!-- ROLE NAME -->
          <label>Role Name <span class="required">*</span></label>
          <input type="text" formControlName="roleName" placeholder="Enter role name" />

          <small *ngIf="roleForm.get('roleName')?.invalid && roleForm.get('roleName')?.touched" class="error-text">
            Role name is required (minimum 3 characters)
          </small>

          <!-- ✅ NEW: ROLE LEVEL (VIEW MODE ONLY) -->
          <div *ngIf="mode === 'view' && roleLevel" style="margin-top: 14px;">
            <label>Role Level</label>
            <div class="read-only-value">
              {{ roleLevel }}
            </div>
          </div>
          <!-- ✅ END NEW -->

        </div>

        <!-- PERMISSIONS -->
        <div class="sub-card">

          <div class="sub-header">
            <h4 class="sub-title">Permissions <span class="required">*</span></h4>

            <div class="flex items-center gap-30">
              <span class="count-text">
                Selected: {{ selectedPermissions.size }} / {{ allPermissions.length }}
              </span>

              <button type="button" class="btn-secondary btn-sm" *ngIf="mode !== 'view'"
                (click)="selectAllPermissions()">
                Select All
              </button>

              <button type="button" class="btn-danger btn-sm" *ngIf="mode !== 'view'"
                (click)="deselectAllPermissions()">
                Deselect All
              </button>
            </div>
          </div>

          <!-- GROUPED PERMISSIONS -->
          <div class="permissions-box">

            <div *ngFor="let scope of permissionTree | keyvalue">

              <!-- SCOPE -->
              <div class="permission-group-title permission-scope-title" (click)="toggleScope(scope.key)">

                <input type="checkbox" [checked]="isScopeSelected(scope.key)" [disabled]="mode === 'view'"
                  (click)="$event.stopPropagation()" (change)="toggleScope(scope.key)" />

                <label class="ml-3 group-label">
                  {{ scope.key | uppercase }}
                </label>
              </div>

              <div class="scope-content">

                <!-- ENTITY -->
                <div *ngFor="let entity of scope.value | keyvalue">

                  <div class="entity-wrapper">
                    <div class="permission-entity-title" (click)="toggleEntity(scope.key, entity.key)">

                      <input type="checkbox" [checked]="isEntitySelected(scope.key, entity.key)"
                        [indeterminate]="isEntityIndeterminate(scope.key, entity.key)" [disabled]="mode === 'view'"
                        (click)="$event.stopPropagation()" (change)="toggleEntity(scope.key, entity.key)" />

                      <span class="entity-label ml-3">
                        {{ entity.key }}
                      </span>

                    </div>
                  </div>

                  <!-- PERMISSIONS -->
                  <div class="permission-children">
                    <div *ngFor="let perm of entity.value" class="permission-item" (click)="togglePermission(perm)">

                      <input type="checkbox" [checked]="isPermissionSelected(perm)" [disabled]="mode === 'view'"
                        (click)="$event.stopPropagation()" (change)="togglePermission(perm)" />

                      <label class="ml-2">{{ perm }}</label>
                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>

          <small *ngIf="selectedPermissions.size === 0" class="error-text">
            Please select at least one permission.
          </small>
        </div>

        <!-- ACTIONS -->
        <div class="form-actions">
          <button type="button" class="btn-secondary" (click)="backToRoles()">
            Cancel
          </button>

          <!-- CREATE MODE -->
          <button *ngIf="mode === 'create'" type="button" class="btn-primary" (click)="createRole()"
            [disabled]="roleForm.invalid || selectedPermissions.size === 0">
            + Create Role
          </button>

          <!-- EDIT MODE -->
          <button *ngIf="mode === 'edit'" type="button" class="btn-primary" (click)="savePermissions()"
            [disabled]="selectedPermissions.size === 0">
            💾 Save Permissions
          </button>
        </div>

      </form>

    </div>

  </div>
</section>